import { styled } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'

export const StyledGrid = styled(Grid)(({ theme }) => ({
  boxShadow: theme.palette.shadows.main,
  background: theme.palette.other.white,
  minHeight: '87vh',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '71vw !important',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '90vw !important',
  },
}))

export const useStyles = makeStyles((theme) => ({
  carousel: {
    textAlign: 'left',
    width: '100%',
    maxHeight: ({ step }) => {
      switch (step) {
        case 0:
          return '87vh'
        case 1:
          return '100vh'
        default:
          return 'none'
      }
    },
    [theme.breakpoints.down('1366.05')]: {
      maxHeight: ({ step }) => {
        switch (step) {
          case 0:
            return '87vh'
          default:
            return 'none'
        }
      },
    },
    [theme.breakpoints.down('1024.05')]: {
      maxHeight: ({ step }) => 'none',
    },
  },
}))
